/**
 * This type is being used only for the component LaneInformation
 */
export type StopInfo = {
  stopTitle: string
  stopSubtitle: string
}

export function isLast(index: number, stops: StopInfo[]) {
  return index === stops.length - 1
}
